export default "__VITE_ASSET__BcYtADA0__"